var PopupCampaignObject = {
		pageName:'',
		isPriceDetailPage:false,
		couponCode:null,
		couponCodeId:0,
		discountMessage:'',
		couponSource:null
}

$(document).ready(function(){
	StyleLoader.addStyle('/css/newui/popupCampaign.css?v1.07');
	StyleLoader.addStyle('/js/jq/flipclock/flipclock.css?v1.0');
	
	var campaignPopup = POPUP.campaign(
			PopupCampaignObject.couponCode, 
			PopupCampaignObject.couponCodeId, 
			PopupCampaignObject.discountMessage, 
			PopupCampaignObject.pageName, 
			PopupCampaignObject.couponSource);	
	
	if(campaignPopup && campaignPopup.isCampaignActive()) {
		
		campaignPopup.startTimer();//timer ı göstermeden arka planda çalıştırıyoruz. Yoksa bir önceki sayfaya geldiğinde ilerlememiş oluyor.

		var couponTime = $.cookie('publicCouponTime');

		if(couponTime > 0 && !PopupCampaignObject.isPriceDetailPage){ //price detail de coupon check validation servisinden dönen sonuca göre mesaj gösterildiğinden timer default olarak gösterilmez.
			campaignPopup.showTimer();
		}	
	}
	
	
});